import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow-left",
  "use": "icon-arrow-left-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-arrow-left\"><path d=\"M20.794 11.04H5.69l9.04-7.686A.2.2 0 0014.595 3h-2.284c-.1 0-.196.035-.271.099l-9.755 8.29a.809.809 0 00-.285.61.794.794 0 00.285.61l9.812 8.34c.038.033.085.051.134.051h2.362c.19 0 .279-.233.134-.354L5.69 12.961h15.104a.205.205 0 00.206-.203v-1.516a.205.205 0 00-.206-.203z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol